import script from "./xtx-numbox.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-numbox.vue?vue&type=script&setup=true&lang=js"

import "./xtx-numbox.vue?vue&type=style&index=0&id=5b00015a&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b00015a"]])

export default __exports__